import React, { useEffect } from 'react'
import { Platform, ScrollView, View } from 'react-native'
import Modal from '@ui/components/Modal'
import { AuthVerifyContent } from '@user/modals/CustomerLogin/AuthVerifyContent'
import AnimatedModalPanel from '@ui/animated/AnimatedModalPanel'
import Glass from '@ui/elements/Glass'
import { useStaffLoginCustomer } from 'hooks/useStaffLoginCustomer'
import { LoadingFooter } from '@ui/lists/LoadingFooter'
import { colors } from '@ui/colors'
import { useSubmitAuthCode } from './modals/CustomerLogin/Strategies/useSubmitAuthCode'
import { useStaff } from 'hooks/useSession'
import { Customer } from '@ca/common/types'
import cn from '@ui/utils/cn'

const StaffCustomerLoginModal = ({
  verify,
  onSuccess,
  auto,
}: {
  verify: ReturnType<typeof useStaffLoginCustomer>
  auto?: boolean
  onSuccess?: (data: Customer) => void
}) => {
  const isLoading = !!auto && !!verify.result
  const isResult = !!verify.result
  const isOpen = isResult || isLoading

  const staff = useStaff()

  const submitAuth = useSubmitAuthCode({
    login: verify?.result?.login || '',
    strategy: 'staff',
    id: verify?.customer?.id,
    replace: false,
    onSuccess,
  })

  useEffect(() => {
    if (!auto || !verify.result || !staff?.ref) {
      return
    }
    submitAuth.onSubmit(staff.ref)
  }, [auto, verify.result])

  return (
    <Modal enabled={isOpen} onClose={verify.cancel} backdropClose={!isLoading}>
      {isLoading && (
        <View className="absolute left-0 top-0 h-full w-full items-center justify-center">
          <LoadingFooter
            color={colors.white}
            className={cn(
              'p-0',
              Platform.select({
                // This crashes on ios as the style includes rotate: 0 without deg
                web: 'scale-[2]',
                default: '',
              })
            )}
          />
        </View>
      )}
      {!auto && isResult && (
        <AnimatedModalPanel>
          <Glass>
            <ScrollView
              overScrollMode="never"
              className="w-full"
              bounces={false}
              keyboardShouldPersistTaps="handled"
            >
              <View className="items-center gap-4 overflow-hidden p-16 pt-8">
                <AuthVerifyContent
                  replace={false}
                  onSuccess={onSuccess}
                  customer={verify.customer}
                  verifyRes={verify.result || null}
                />
              </View>
            </ScrollView>
          </Glass>
        </AnimatedModalPanel>
      )}
    </Modal>
  )
}

export default StaffCustomerLoginModal
